import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cardTight, sectionTitle, textMeta } from '../../uiStyles';

type ToggleOption = {
  id: string;
  label: string;
  value: boolean;
  onToggle: () => void;
  title?: string;
};

type GradeSyncOptionsCardProps = {
  options: ToggleOption[];
  description: string;
};

export function GradeSyncOptionsCard({
  options,
  description,
}: GradeSyncOptionsCardProps): ReactNode {
  const { t } = useTranslation();
  return (
    <section className={cardTight}>
      <p className={sectionTitle}>{t('gradeSync.preflight.optionsCard.teacherActions')}</p>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-2">
        {options.map((opt) => (
          <button
            key={opt.id}
            type="button"
            role="switch"
            aria-checked={opt.value}
            onClick={opt.onToggle}
            title={opt.title}
            className={`px-3 py-2 rounded-xl border text-[10px] font-black uppercase tracking-widest whitespace-nowrap transition-colors ${
              opt.value
                ? 'bg-emerald-500/15 border-emerald-500/30 text-emerald-700 dark:text-emerald-300'
                : 'bg-white/60 dark:bg-slate-900/40 border-slate-200/70 dark:border-slate-700/60 text-slate-700 dark:text-slate-200'
            }`}
          >
            {opt.label}:{' '}
            {opt.value
              ? t('gradeSync.preflight.optionsCard.on')
              : t('gradeSync.preflight.optionsCard.off')}
          </button>
        ))}
      </div>
      <p className={`mt-2 ${textMeta}`}>{description}</p>
    </section>
  );
}
